import { TFunction } from 'i18next'
import { Building2, Users } from 'lucide-react'
import Active from './Active'
import Candidates from './Candidates'

export const tabs = (t: TFunction) => [
    {
        label: t('official_resellers'),
        value: 'official',
        startIcon: <Building2 className="w-4 h-4" />,
        component: <Active />,
    },
    {
        label: t('candidates'),
        value: 'candidates',
        startIcon: <Users className="w-4 h-4" />,
        component: <Candidates />,
    },
]
